'use strict';

angular.module('shiftTraderApp')
  .factory('DaysOffUserStatsService', ['$injector', 'AvailabilityRules', 'TimeService', function ($injector, AvailabilityRules, TimeService) {

      var DaysOffUserStats = function() {
        var D = {
          state: {
            activeDataReturned: false,
            inactiveDataReturned: false,
            currentUser: undefined,
            startDate: undefined,
            calculationInProgress: false
          },
          data: {},
          callbackFn: undefined
        };

        D.rawData = [];
        D.data = {
          pending: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          },
          approved: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          },
          disapproved: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          },
          expired: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          },
          cancelled: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          },
          removed: {
            requestsCount: 0,
            fullDayCount: 0,
            partialDayCount: 0,
            items: []
          }
        };

        D.init = function(user, startDateMoment, postCalcCallback, fetchNow) {
          D.state.currentUser = user;
          D.state.startDate = startDateMoment;

          if (postCalcCallback) {
            D.callbackFn = postCalcCallback;
          }

          if (fetchNow) {
            D.getDaysOffFromServer();
          }
        };

        var calcDaysOffInfo = function() {
          D.state.calculationInProgress = true;

          D.data.pending.items = _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$isPending() && !dayoff.$isExpired();
          }), function(x) {
            return x.start.unix() * -1;
          });

          D.data.approved.items= _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$isApproved();
          }), function(x) {
            return x.start.unix() * -1;
          });

          D.data.disapproved.items = _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$isDisapproved();
          }), function(x) {
            return x.start.unix() * -1;
          });

          D.data.expired.items = _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$isExpired();
          }), function(x) {
            return x.start.unix() * -1;
          });

          D.data.cancelled.items = _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$isCancelled();
          }), function(x) {
            return x.start.unix() * -1;
          });

          D.data.removed.items = _.sortBy(_.where(D.rawData, function(dayoff) {
            return dayoff.$wasRemoved();
          }), function(x) {
            return x.start.unix() * -1;
          });

          _.each(['pending', 'approved', 'disapproved', 'expired', 'cancelled', 'removed'], function(cat) {
            D.data[cat].requestsCount = D.data[cat].items.length;
            var res;

            _.each(D.data[cat].items, function(dayoff) {
              res = dayoff.$getNumberOfFullAndPartialDays();
              D.data[cat].fullDayCount += res.full;
              D.data[cat].partialDayCount += res.part;
            });
          });

          if (D.callbackFn) {
            D.callbackFn();
          }
          D.state.calculationInProgress = false;
        };

        D.getDaysOffFromServer = function() {
          AvailabilityRules.getAll({
            type: 'daysoff',
            active: true,
            status: 'any',
            start_date: D.state.startDate.format('YYYY-MM-DD'),
            user_id: D.state.currentUser.id
          })
              .then(function(data) {
                D.rawData.push.apply(D.rawData, _.map(data, function(datum) { datum._mif = TimeService.minimalIntervalTimeFormat(datum.range_twix); return datum;}));
                if (D.state.inactiveDataReturned) {
                  calcDaysOffInfo();
                }
                D.state.activeDataReturned = true;
              }, function() {
                console.log('issue fetching availability data');
              });

          AvailabilityRules.getAll({
            type: 'daysoff',
            active: false,
            status: 'any',
            start_date: D.state.startDate.format('YYYY-MM-DD'),
            user_id: D.state.currentUser.id
          })
              .then(function(data) {
                D.rawData.push.apply(D.rawData, _.map(data, function(datum) { datum._mif = TimeService.minimalIntervalTimeFormat(datum.range_twix); return datum;}));
                if (D.state.activeDataReturned) {
                  calcDaysOffInfo();
                }
                D.state.inactiveDataReturned = true;
              }, function() {
                console.log('issue fetching availability data');
              });
        };

        D.addRequestsAndRecalculate = function(requests) {
          D.rawData.push.apply(D.rawData, requests);
          calcDaysOffInfo();
        };

        D.isDataLoadedAndProcessed = function() {
          return D.state.activeDataReturned && D.state.inactiveDataReturned && !D.state.calculationInProgress;
        };

        return D;
      };

      return {
        initializeInstance: function() {
          return new DaysOffUserStats();
        }
      };
  }]);
